import { QuizzQuestionYesOrNo, RegimeValues } from '../types'
import { RecipeCategory } from '../types/fam-graphql'

export enum TcPageTemplateNames {
  Home = 'accueil',
  Form = 'formulaire',
  Recipe = 'page recette',
  Recipes = 'page liste recettes',
  Article = 'page article',
  Articles = 'page liste articles',
  Activity = 'page activité',
  Activities = 'page liste activités',
  RecipeSearch = 'page de résultat (recherche interne)',
  Preferences = 'page préférences et objectifs',
  Groceries = 'page liste de courses',
  Another = 'autre contenu',
  Account = 'page mon compte',
  QuizzLanding = 'page accueil quizz',
  EventLanding = 'page accueil enmodedeter',
  EventDetails = 'page détails enmodedeter',
  Hebdo = 'page hebdo',
  Settings = 'page réglages',
}

export enum TcFormNames {
  Onboarding = 'questionnaire menu perso',
  Quizz = 'test ap ados',
}

export enum TcClickTypes {
  navigation = 'navigation',
  exit = 'exit',
  download = 'download',
  action = 'action',
}

export const OnboardingStepNames = [
  '1- nombre personnes à table',
  '2- alimentation particulière',
  '3- composition repas',
  '4- temps en cuisine',
  '5- nombre de repas',
  '6- objectifs alimentaires',
  '7- fruits et légumes',
  '8- féculents complets',
  '9- légumes secs',
  '10- poisson',
  '11- viande',
  '12- boissons et produits sucrés',
  '13- validation menu personnalisé',
]

export const OnboardingStepValues = [
  'nombre_personnes',
  'pratique_alimentaire',
  'composition_repas',
  'temps_cuisine',
  'nombre_repas',
  'goal_fruit_vegetable',
  'goal_starchy',
  'goal_dried_vegetable',
  'goal_fish',
  'goal_meat',
]

export const tcRegimeFilterValues = {
  [RegimeValues.NONE]: 'aucun',
  [RegimeValues.NO_EGG]: 'ni oeuf',
  [RegimeValues.NO_FISH]: 'ni poisson',
  [RegimeValues.NO_MEAT]: 'sans viande',
  [RegimeValues.NO_PORK]: 'sans porc',
}

export const tcRecipeCategoryFilterValues = {
  [RecipeCategory.Course]: 'plats',
  [RecipeCategory.Side]: 'accompagnements',
  [RecipeCategory.Dessert]: 'desserts',
  [RecipeCategory.Start]: 'entrées',
  [RecipeCategory.Other]: 'autres',
  [RecipeCategory.FullCourse]: 'complet',
}

export const tcRecipeFilterTitle = {
  courseType: 'Type de plat',
  diet: 'Alimentation particulière',
  cookingTime: 'Temps passé en cuisine',
  recipeMainComponent: 'Recettes équivalentes sur le plan nutritionnel',
}

export const QuizzStepNames = (typeOfUser: string, quizzValues: any) => {
  const lcTypeOfUser = typeOfUser.toLowerCase()
  return [
    '0 - ouverture',
    `1 - ${lcTypeOfUser}_trajets cours_condition`,
    ...(quizzValues.question2 === QuizzQuestionYesOrNo.NO
      ? []
      : [`2 - ${lcTypeOfUser}_trajets cours_frequence`]),
    ...(quizzValues.question2 === QuizzQuestionYesOrNo.NO
      ? []
      : [`3 - ${lcTypeOfUser}_trajets cours_duree`]),
    `4 - ${lcTypeOfUser}_autres trajets_condition`,
    ...(quizzValues.question5 === QuizzQuestionYesOrNo.NO
      ? []
      : [`5 - ${lcTypeOfUser}_autres trajets_frequence`]),
    ...(quizzValues.question5 === QuizzQuestionYesOrNo.NO
      ? []
      : [`6 - ${lcTypeOfUser}_autres trajets_duree`]),
    `7 - ${lcTypeOfUser}_eps_duree`,
    `8 - ${lcTypeOfUser}_jeux recre_condition`,
    ...(quizzValues.question9 === QuizzQuestionYesOrNo.NO
      ? []
      : [`9 - ${lcTypeOfUser}_jeux recre_frequence`]),
    ...(quizzValues.question9 === QuizzQuestionYesOrNo.NO
      ? []
      : [`10 - ${lcTypeOfUser}_jeux recre_duree`]),
    `11 - ${lcTypeOfUser}_extra scolaire_condition`,
    ...(quizzValues.question11 === QuizzQuestionYesOrNo.NO
      ? []
      : [`12 - ${lcTypeOfUser}_extra scolaire_frequence`]),
    ...(quizzValues.question11 === QuizzQuestionYesOrNo.NO
      ? []
      : [`13 - ${lcTypeOfUser}_extra scolaire_duree`]),
    `14 - ${lcTypeOfUser}_autres activites_condition_intense`,
    `15 - ${lcTypeOfUser}_autres activites_condition_moderee`,
    ...(quizzValues.question14 === QuizzQuestionYesOrNo.YES
      ? [`16 - ${lcTypeOfUser}_autres activites_frequence_duree_intense`]
      : []),
    ...(quizzValues.question14_bis === QuizzQuestionYesOrNo.YES
      ? [`17 - ${lcTypeOfUser}_autres activites_frequence_duree_moderee`]
      : []),
    `18 - ${lcTypeOfUser}_pauses_duree_week`,
    `19 - ${lcTypeOfUser}_pauses_duree_weekend`,
  ]
}

export const sharedTagCommanderVariables = {
  level2_id: '2',
  level2_name: 'FAM',
  contains_user_infos: false,
  contains_form_infos: false,
  contains_filter_infos: false,
  contains_goal_infos: false,
  contains_preference_infos: false,
}

export default {
  envWork: process.env.COMMANDER_ENV,
  scriptHead: process.env.COMMANDER_HEAD,
}
